import { RootState } from '@app/redux/root-reducer';

export const selectOrderDetailState = (store: RootState) => store.orderDetailSlice.getOrderDetails;
export const selectUpdateOrderStatusState = (store: RootState) =>
  store.orderDetailSlice.updateOrderStatus;
export const selectSlotsByDateTypeState = (store: RootState) => store.orderDetailSlice.slots;
export const selectChangeDeliverySlotState = (store: RootState) =>
  store.orderDetailSlice.changedDeliverySlot;
